<template>
  <div class="table_wrap">
    <div class="filter_wrap">
      <div class="filter_row">
        <div class="filter_content">
          <div class="filter_titleBox mr15 inline-block">
            <span class="filter_title">작성일</span>
          </div>
          <div class="filter inline-block">
            <el-date-picker
                class="datePicker_long"
                v-model="filterDate"
                type="daterange"
                value-format="yyyy-MM-dd"
                @change="setFilterFunc('cr', filterDate)"
                start-placeholder="시작일"
                end-placeholder="종료일">
              :editable="false"
            </el-date-picker>
          </div>
        </div>
      </div>
      <div class="filter_row">
        <div class="filter_content">
          <div class="filter_titleBox mr15">
            <span class="filter_title">답변상태</span>
          </div>
          <el-select v-model="qaStatus" class="select mr5" @change="setFilterFunc('isa', qaStatus)">
            <el-option :value="''" :label="'전체'"></el-option>
            <el-option :value="0" :label="`대기`"></el-option>
            <el-option :value="1" :label="`완료`"></el-option>
          </el-select>
        </div>
      </div>
      <div class="filter_row">
        <div class="filter_content ">
          <div class="filter_titleBox mr15">
            <span class="filter_title">검색</span>
          </div>
          <el-select v-model="searchInputOption" class="select mr5">
            <el-option :value="'mbid'" :label="'아이디'"></el-option>
            <el-option :value="'mbna'" :label="'이름'"></el-option>
            <el-option :value="'su'" :label="'제목'"></el-option>
          </el-select>
          <div class="filter">
            <el-input
                class="shortest mr10"
                v-model="searchInput"
                size=""
                placeholder="검색어를 입력해 주세요."
                maxLength="30"
                @keyup.enter.native="setFilterFunc(searchInputOption, searchInput)"
            >
            </el-input>
            <el-button class="com_search" @click="setFilterFunc(searchInputOption, searchInput)">
              검색
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="filter-show-count mt15 mb15">
      <el-select v-model="size" @change="changePage('size', size)">
        <el-option v-for="(sizeData) in sizeList" :key="`size${sizeData}`" :value="sizeData"
                   :label="`${sizeData}개씩 보기`"></el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import util from "@/mixins/util";
import boardFilterUtil from "@/components/board/boardFilterUtil";
import {mapState} from "vuex";
import {appLanguage} from "@/service/languageService";

const {filterConfig} = boardFilterUtil
export default {
  name: "BoardFilterQnaLayout",
  mixins: [boardFilterUtil],
  components: {},

  provide() {
    return {}
  },
  inject: ['setPage', 'setFilter'],
  props: {
    filterData: {
      default: () => {
        return {}
      }
    },
    paginationData: {
      type: Object,
      default: {
        total: 0,
        page: 0,
        size: 0,
      }
    },
  },
  data() {
    return {
      searchInputOption: 'mbid',
      qaStatus: '',
      searchInput: '',
      filterDate: '',
      size: 10,
      sizeList: [10, 30, 50],
    }
  },
  created() {
  },
  mounted() {
    this.setterFilterDataInData();
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    setterFilterDataInData() {
      let classnames = Object.keys(this.filterData);
      classnames.forEach(classname => {
        let obj = this.filterData[classname];
        let type = filterConfig[obj.key].type;
        if (this.hasOwnProperty(classname)) {
          // this[classname] =
          if (type == 'query') {
            this[classname] = obj.query;
            if (this.hasOwnProperty(classname + 'Option')) {
              this[classname + 'Option'] = obj.key;
            }
          } else if (type === 'between') {
            this[classname] = [obj.start, obj.end];
          } else if (type === 'match') {
            if (isNaN(obj.value)) {
              this[classname] = obj.value;
            } else {
              this[classname] = Number(obj.value);
            }

          }

        }
      })
      this.size = this.paginationData.size;
    },
    setFilterFunc(key, value) {
      this.setFilter(key, value);
    },

    checkFilterData() {
      return this.filterDate != null && this.filterDate.length > 0;
    },
    changePage(key, value) {
      this.setPage(key, value);
      this.setPage('page', 1);
    },

  },
  watch: {},
}
</script>

<style scoped>

</style>
